import {
  FETCH_LEAVE_ALLOCATION_REQUEST, FETCH_LEAVE_ALLOCATION_SUCCESS, FETCH_LEAVE_ALLOCATION_FAIL,
  CLEAR_LEAVE_ALLOCATION,
  FETCH_LEAVE_SUMMARY_REQUEST, FETCH_LEAVE_SUMMARY_SUCCESS, FETCH_LEAVE_SUMMARY_FAIL,
} from "../../constants/Leave/LeaveAllocationConstants";

const initialState = {
  loading: false, data: [], error: null,                    // one employee's allocation
  summaryLoading: false, summary: [], summaryError: null,   // everyone's totals
};

const LeaveAllocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LEAVE_ALLOCATION_REQUEST:
      return { ...state, loading: true, data: [], error: null };
    case FETCH_LEAVE_ALLOCATION_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_LEAVE_ALLOCATION_FAIL:
      return { ...state, loading: false, data: [], error: action.payload };
    case CLEAR_LEAVE_ALLOCATION:
      return { ...state, loading: false, data: [], error: null };

    case FETCH_LEAVE_SUMMARY_REQUEST:
      return { ...state, summaryLoading: true, summaryError: null };
    case FETCH_LEAVE_SUMMARY_SUCCESS:
      return { ...state, summaryLoading: false, summary: action.payload };
    case FETCH_LEAVE_SUMMARY_FAIL:
      return { ...state, summaryLoading: false, summary: [], summaryError: action.payload };
    default:
      return state;
  }
};

export default LeaveAllocationReducer;